import { candidateJobService } from '@/services/api/candidateJob.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { candidateJobModel } from '@/models/api/candidateJob.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const CANDIDATE_JOB_MODULE = "api/candidateJob";

// ACTIONS
export const GET_ALL_CANDIDATE_JOB = 'getAllCandidateJob';
export const CREATE_CANDIDATE_JOB = 'createCandidateJob';
export const GET_CANDIDATE_JOB = 'getCandidateJob';
export const UPDATE_CANDIDATE_JOB = 'updateCandidateJob';
export const UPDATE_CANDIDATE_JOB_STATUS = 'updateCandidateJobStatus';
export const UPLOAD_CANDIDATE_JOB_IMAGE = 'uploadCandidateJobImage';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_CANDIDATE_JOB_SUCCESS = "allCandidateJobSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_CANDIDATE_JOB_SUCCESS = "getCandidateJobSuccess";

export const actions = {
    [GET_ALL_CANDIDATE_JOB]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        candidateJobService
            .getAll(filter)
            .then((result) => {
                commit(ALL_CANDIDATE_JOB_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_CANDIDATE_JOB]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return candidateJobService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE_JOB, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_CANDIDATE_JOB]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return candidateJobService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_CANDIDATE_JOB_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_CANDIDATE_JOB]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return candidateJobService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE_JOB, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPLOAD_CANDIDATE_JOB_IMAGE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return candidateJobService
            .uploadImage(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_CANDIDATE_JOB_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return candidateJobService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE_JOB, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_CANDIDATE_JOB_SUCCESS](state, {data}) {
        let candidateJob = data.data || [];
        state.list.data = candidateJob;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = candidateJob.map(item => candidateJobModel(item));
        }
    },
    [GET_CANDIDATE_JOB_SUCCESS](state, data) {
        state.details = candidateJobModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
